/**
 * Tests for analytics events handling in API functions
 */

import { refreshReducersFromResponse, trackAnalyticEventsFromError } from '../api_functions';

jest.mock('../../actions/analytics', () => ({
  parseAndTrackAnalyticEvents: jest.fn()
}));

// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const { parseAndTrackAnalyticEvents } = require('../../actions/analytics');

Object.defineProperty(window, 'store', {
  value: { dispatch: jest.fn() },
  writable: true
});

describe('API Analytics Events', () => {
  beforeEach(() => {
    jest.clearAllMocks();
  });

  describe('refreshReducersFromResponse', () => {
    it('calls parseAndTrackAnalyticEvents when analyticEvents present', () => {
      const events = [{ event: 'test', properties: {} }];
      const response = { user: { id: 1 }, analyticEvents: events };

      refreshReducersFromResponse(response);

      expect(parseAndTrackAnalyticEvents).toHaveBeenCalledWith(events);
    });

    it('does not call parseAndTrackAnalyticEvents when analyticEvents missing', () => {
      const response = { user: { id: 1 } };

      refreshReducersFromResponse(response);

      expect(parseAndTrackAnalyticEvents).not.toHaveBeenCalled();
    });

    it('calls parseAndTrackAnalyticEvents with empty object', () => {
      const response = { user: { id: 1 }, analyticEvents: {} };

      refreshReducersFromResponse(response);

      expect(parseAndTrackAnalyticEvents).toHaveBeenCalledWith({});
    });
  });

  describe('trackAnalyticEventsFromError', () => {
    it('calls parseAndTrackAnalyticEvents when error contains analyticEvents', async () => {
      const error = {
        json: jest.fn().mockResolvedValue({
          analyticEvents: [{ event: 'error', properties: { status: 500 } }]
        })
      };

      await trackAnalyticEventsFromError(error);

      expect(parseAndTrackAnalyticEvents).toHaveBeenCalledWith([
        { event: 'error', properties: { status: 500 } }
      ]);
    });

    it('does not call parseAndTrackAnalyticEvents when error lacks analyticEvents', async () => {
      const error = {
        json: jest.fn().mockResolvedValue({ error: 'message' })
      };

      await trackAnalyticEventsFromError(error);

      expect(parseAndTrackAnalyticEvents).not.toHaveBeenCalled();
    });
  });
});
